import { NeMoPretrainedModel } from "./types";


export const NEMO_PRETRAINED_MODELS: NeMoPretrainedModel[] = [
  // ============================================
  // LLM Models
  // ============================================
  {
    id: 'llama-3.1-8b-instruct',
    name: 'llama-3.1-8b-instruct',
    displayName: 'Llama 3.1 8B Instruct',
    task: 'llm',
    family: 'Llama',
    description: 'Meta\'s instruction-tuned Llama 3.1 with 8B parameters, excellent for fine-tuning on custom tasks',
    parameters: '8B',
    vramRequired: 32,
    vramLoRA: 16,
    contextLength: 128000,
    ngcPath: 'nvidia/nemo-llm/llama-3.1-8b-instruct',
    supportedMethods: ['sft', 'lora', 'qlora', 'ptuning'],
    pretrainedDataset: 'Llama 3.1 Training Mix',
    useCases: ['Chatbots', 'Content generation', 'Code assistance', 'Question answering'],
    strengths: ['Long context window', 'Strong instruction following', 'Efficient for LoRA', 'Good multilingual support'],
    limitations: ['Requires significant VRAM for full fine-tuning', 'May hallucinate on niche topics'],
    license: 'Llama 3.1 Community License',
    paperReference: 'https://arxiv.org/abs/2407.21783',
    outputClasses: 128256,
    outputClassNames: ['Text Generation', 'Chat/Conversation', 'Code Generation', 'Question Answering', 'Summarization', 'Translation', 'Instruction Following', 'Creative Writing', 'Analysis', 'Reasoning'],
  },
  {
    id: 'llama-3.1-70b-instruct',
    name: 'llama-3.1-70b-instruct',
    displayName: 'Llama 3.1 70B Instruct',
    task: 'llm',
    family: 'Llama',
    description: 'Large-scale Llama 3.1 model with superior reasoning capabilities',
    parameters: '70B',
    vramRequired: 140,
    vramLoRA: 80,
    contextLength: 128000,
    ngcPath: 'nvidia/nemo-llm/llama-3.1-70b-instruct',
    supportedMethods: ['sft', 'lora', 'qlora'],
    pretrainedDataset: 'Llama 3.1 Training Mix',
    useCases: ['Complex reasoning', 'Advanced code generation', 'Research assistance', 'Enterprise applications'],
    strengths: ['State-of-the-art performance', 'Excellent reasoning', 'Strong factual accuracy'],
    limitations: ['Very high VRAM requirement', 'Slow inference without optimization'],
    license: 'Llama 3.1 Community License',
    paperReference: 'https://arxiv.org/abs/2407.21783',
    outputClasses: 128256,
    outputClassNames: ['Advanced Reasoning', 'Complex Analysis', 'Code Generation', 'Research Assistance', 'Enterprise QA', 'Document Understanding', 'Multi-step Planning', 'Mathematical Reasoning', 'Scientific Writing', 'Data Analysis'],
  },
  {
    id: 'mistral-7b-instruct-v0.3',
    name: 'mistral-7b-instruct-v0.3',
    displayName: 'Mistral 7B Instruct v0.3',
    task: 'llm',
    family: 'Mistral',
    description: 'Efficient instruction-tuned model with excellent performance-to-size ratio',
    parameters: '7B',
    vramRequired: 28,
    vramLoRA: 14,
    contextLength: 32768,
    ngcPath: 'nvidia/nemo-llm/mistral-7b-instruct-v0.3',
    supportedMethods: ['sft', 'lora', 'qlora', 'ptuning'],
    pretrainedDataset: 'Mistral Training Mix',
    useCases: ['General chat', 'Summarization', 'Translation', 'Code completion'],
    strengths: ['Very efficient', 'Fast inference', 'Good for deployment', 'Sliding window attention'],
    limitations: ['Shorter context than Llama 3.1', 'Less multilingual capability'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2310.06825',
    outputClasses: 32000,
    outputClassNames: ['General Chat', 'Summarization', 'Translation', 'Code Completion', 'Text Classification', 'Entity Extraction', 'Sentiment Analysis', 'Content Generation'],
  },
  {
    id: 'gemma-2-9b-instruct',
    name: 'gemma-2-9b-instruct',
    displayName: 'Gemma 2 9B Instruct',
    task: 'llm',
    family: 'Gemma',
    description: 'Google\'s open model optimized for instruction following',
    parameters: '9B',
    vramRequired: 36,
    vramLoRA: 18,
    contextLength: 8192,
    ngcPath: 'nvidia/nemo-llm/gemma-2-9b-instruct',
    supportedMethods: ['sft', 'lora', 'qlora'],
    pretrainedDataset: 'Gemma Training Mix',
    useCases: ['Education', 'Content moderation', 'Creative writing', 'Data analysis'],
    strengths: ['Strong safety alignment', 'Good at following constraints', 'Efficient architecture'],
    limitations: ['Shorter context window', 'Less code capability than Llama'],
    license: 'Gemma Terms of Use',
    paperReference: 'https://arxiv.org/abs/2408.00118',
    outputClasses: 256000,
    outputClassNames: ['Educational Content', 'Content Moderation', 'Creative Writing', 'Data Analysis', 'Safe Generation', 'Structured Output', 'Classification', 'Explanation'],
  },
  {
    id: 'qwen-2.5-7b-instruct',
    name: 'qwen-2.5-7b-instruct',
    displayName: 'Qwen 2.5 7B Instruct',
    task: 'llm',
    family: 'Qwen',
    description: 'Alibaba\'s multilingual model with strong performance across languages',
    parameters: '7B',
    vramRequired: 28,
    vramLoRA: 14,
    contextLength: 131072,
    ngcPath: 'nvidia/nemo-llm/qwen-2.5-7b-instruct',
    supportedMethods: ['sft', 'lora', 'qlora', 'ptuning'],
    pretrainedDataset: 'Qwen Training Mix',
    useCases: ['Multilingual applications', 'Chinese NLP', 'Long document processing', 'Code generation'],
    strengths: ['Best-in-class multilingual', 'Very long context', 'Strong coding ability', 'Efficient tokenizer'],
    limitations: ['May have cultural biases', 'Complex licensing for commercial use'],
    license: 'Qwen License',
    paperReference: 'https://arxiv.org/abs/2407.10671',
    outputClasses: 151936,
    outputClassNames: ['Multilingual Generation', 'Chinese NLP', 'Long Document Processing', 'Code Generation', 'Cross-lingual Translation', 'Mathematical Reasoning', 'Structured Data', 'JSON/XML Output'],
  },
  // ============================================
  // ASR Models
  // ============================================
  {
    id: 'parakeet-ctc-1.1b',
    name: 'parakeet-ctc-1.1b',
    displayName: 'Parakeet CTC 1.1B',
    task: 'asr',
    family: 'Parakeet',
    description: 'State-of-the-art English ASR model with FastConformer architecture',
    parameters: '1.1B',
    vramRequired: 16,
    vramLoRA: 8,
    languages: ['en'],
    ngcPath: 'nvidia/nemo-asr/parakeet-ctc-1.1b',
    supportedMethods: ['full', 'sft', 'lora'],
    pretrainedDataset: '64K hours English speech',
    useCases: ['Transcription', 'Voice assistants', 'Call center analytics', 'Meeting notes'],
    strengths: ['Industry-leading WER', 'Robust to noise', 'Fast inference', 'Streaming support'],
    limitations: ['English only', 'May struggle with heavy accents'],
    license: 'CC-BY-4.0',
    paperReference: 'https://arxiv.org/abs/2305.05084',
    outputClasses: 1024,
    outputClassNames: ['A-Z Characters', 'Digits 0-9', 'Punctuation', 'Space', 'Apostrophe', 'Blank Token', 'Word Boundaries', 'Sentence End'],
  },
  {
    id: 'parakeet-rnnt-1.1b',
    name: 'parakeet-rnnt-1.1b',
    displayName: 'Parakeet RNNT 1.1B',
    task: 'asr',
    family: 'Parakeet',
    description: 'Streaming-optimized ASR with RNN-Transducer decoder',
    parameters: '1.1B',
    vramRequired: 16,
    vramLoRA: 8,
    languages: ['en'],
    ngcPath: 'nvidia/nemo-asr/parakeet-rnnt-1.1b',
    supportedMethods: ['full', 'sft', 'lora'],
    pretrainedDataset: '64K hours English speech',
    useCases: ['Real-time transcription', 'Live captioning', 'Voice commands', 'Streaming applications'],
    strengths: ['Low latency streaming', 'Better for real-time', 'Good accuracy'],
    limitations: ['Slightly lower accuracy than CTC', 'English only'],
    license: 'CC-BY-4.0',
    paperReference: 'https://arxiv.org/abs/2305.05084',
    outputClasses: 1024,
    outputClassNames: ['A-Z Characters', 'Digits 0-9', 'Punctuation', 'Space', 'Blank Token', 'Streaming Tokens', 'Real-time Output'],
  },
  {
    id: 'canary-1b',
    name: 'canary-1b',
    displayName: 'Canary 1B Multilingual',
    task: 'asr',
    family: 'Canary',
    description: 'Multilingual ASR supporting English, German, French, and Spanish',
    parameters: '1B',
    vramRequired: 16,
    vramLoRA: 8,
    languages: ['en', 'de', 'fr', 'es'],
    ngcPath: 'nvidia/nemo-asr/canary-1b',
    supportedMethods: ['full', 'sft', 'lora'],
    pretrainedDataset: '86K hours multilingual speech',
    useCases: ['International applications', 'European market', 'Translation', 'Multilingual support'],
    strengths: ['Multi-language support', 'Code-switching handling', 'Translation capability'],
    limitations: ['Slightly lower per-language accuracy', 'Limited language set'],
    license: 'CC-BY-4.0',
    paperReference: 'https://arxiv.org/abs/2306.04207',
    outputClasses: 4096,
    outputClassNames: ['English Chars', 'German Chars', 'French Chars', 'Spanish Chars', 'Accented Letters', 'Digits', 'Punctuation', 'Language Tags', 'Code-switching'],
  },
  {
    id: 'conformer-ctc-large',
    name: 'conformer-ctc-large',
    displayName: 'Conformer CTC Large',
    task: 'asr',
    family: 'Conformer',
    description: 'Balanced ASR model with good accuracy and efficiency',
    parameters: '120M',
    vramRequired: 8,
    vramLoRA: 4,
    languages: ['en'],
    ngcPath: 'nvidia/nemo-asr/conformer-ctc-large',
    supportedMethods: ['full', 'sft', 'lora'],
    pretrainedDataset: 'LibriSpeech + additional data',
    useCases: ['Edge deployment', 'Mobile apps', 'Resource-constrained environments'],
    strengths: ['Efficient', 'Low VRAM', 'Fast training', 'Good baseline'],
    limitations: ['Lower accuracy than Parakeet', 'English only'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2005.08100',
    outputClasses: 128,
    outputClassNames: ['A-Z Characters', 'Digits 0-9', 'Space', 'Punctuation', 'Blank Token'],
  },
  // ============================================
  // TTS Models
  // ============================================
  {
    id: 'fastpitch-hifigan',
    name: 'fastpitch-hifigan',
    displayName: 'FastPitch + HiFi-GAN',
    task: 'tts',
    family: 'FastPitch',
    description: 'Two-stage TTS: FastPitch for mel spectrogram, HiFi-GAN for waveform synthesis',
    parameters: '30M',
    vramRequired: 8,
    vramLoRA: 4,
    languages: ['en'],
    ngcPath: 'nvidia/nemo-tts/fastpitch-hifigan-en',
    supportedMethods: ['full', 'sft'],
    pretrainedDataset: 'LJSpeech',
    useCases: ['Voice cloning', 'Audiobook generation', 'Accessibility', 'IVR systems'],
    strengths: ['Fast inference', 'High quality', 'Controllable prosody', 'Easy to fine-tune'],
    limitations: ['Single speaker', 'English only baseline'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2006.06873',
    outputClasses: 80,
    outputClassNames: ['Mel Spectrogram Bins', 'Pitch Contour', 'Duration', 'Energy', 'Phoneme Alignment', 'Prosody Control'],
  },
  {
    id: 'vits',
    name: 'vits',
    displayName: 'VITS',
    task: 'tts',
    family: 'VITS',
    description: 'End-to-end TTS with flow-based decoder for natural speech',
    parameters: '45M',
    vramRequired: 8,
    vramLoRA: 4,
    languages: ['en'],
    ngcPath: 'nvidia/nemo-tts/vits-en',
    supportedMethods: ['full', 'sft'],
    pretrainedDataset: 'VCTK',
    useCases: ['Multi-speaker TTS', 'Expressive speech', 'Voice conversion', 'Emotional TTS'],
    strengths: ['End-to-end', 'Multi-speaker support', 'Natural prosody', 'Emotional expression'],
    limitations: ['Slower than two-stage', 'Higher VRAM'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2106.06103',
    outputClasses: 109,
    outputClassNames: ['Speaker Embeddings', 'Phoneme Set', 'Duration Predictor', 'Flow Decoder', 'Waveform Generator', 'Multi-speaker IDs', 'Emotion Control'],
  },
  {
    id: 'radtts',
    name: 'radtts',
    displayName: 'RAD-TTS',
    task: 'tts',
    family: 'RAD-TTS',
    description: 'Flow-based TTS with parallel decoding for fast inference',
    parameters: '40M',
    vramRequired: 8,
    vramLoRA: 4,
    languages: ['en'],
    ngcPath: 'nvidia/nemo-tts/radtts-en',
    supportedMethods: ['full', 'sft'],
    pretrainedDataset: 'HiFi-TTS',
    useCases: ['Low-latency applications', 'Real-time TTS', 'Gaming', 'Virtual assistants'],
    strengths: ['Very fast', 'Good quality', 'Controllable', 'Efficient'],
    limitations: ['Slightly lower quality than VITS', 'Single speaker baseline'],
    license: 'Apache 2.0',
    paperReference: 'https://arxiv.org/abs/2108.00804',
    outputClasses: 80,
    outputClassNames: ['Mel Spectrogram', 'Parallel Decoder', 'Duration', 'Pitch', 'Energy', 'Fast Generation'],
  },
];

